import PieChart, { PieChartProps } from './PieChart.component';

export type PieChartType = PieChartProps;

export default PieChart;
